import employeeType from './employeeType/sagas';
import department from './department/sagas';

export default [
    ...employeeType,
    ...department,
];
